import React, {
  useContext,
  createContext,
  useReducer,
  useEffect,
  useState,
} from 'react';
import TwoCards from '../../../../../../components/Card/TwoCards';
import Form from './Form';
import ExtendedForm from './ExtendedForm';
import reducer from './reducer';
import Button from '@material-ui/core/Button';
import { useParams, useLocation, useHistory } from 'react-router-dom';
import checkCodeMelli from '../../../../../../fns/isValidNationalCode';
import checkMobile from '../../../../../../fns/checkMobilePhone';
import { store as mainStore } from '../../../../../../store';
import axios from 'api/axios';
import useTitle from 'hooks/useTitle';
import { CircularProgress } from '@material-ui/core';

export const store = createContext(null);
const { Provider } = store;

const AddCustomer = () => {
  const { id } = useParams();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const mode = id ? 'edit' : 'add';
  useTitle(mode === 'add' ? 'افزودن صاحب بار' : 'ویرایش صاحب بار');
  const location = useLocation();
  let values =
    location.state && location.state.values ? location.state.values : null;
  const initialState = {
    values: {
      firstName: '',
      lastName: '',
      nationalCode: '',
      mobilePhone: '',
      city: null,
      state: '5e3dbf556b09850543a678b5',
      isVIP: false,
      legal: true,
      company: '',
      companyNationalCode: '',
      phone: '',
      address: '',
      zipcode: '',
    },
    error: {},
  };
  const [state, dispatch] = useReducer(reducer, initialState);
  const { showMessage, showError } = useContext(mainStore);

  const validation = (e) => {
    const isSingleValidation = e || false;
    let er = {};

    // Validation patterns start here:
    if (!state.values.firstName || state.values.firstName.length < 2) {
      er.firstName = 'نام بایستی حداقل ۲ داشته باشد.';
    }
    if (!state.values.lastName || state.values.lastName.length < 3) {
      er.lastName = 'نام بایستی حداقل ۳ داشته باشد.';
    }
    // if (!checkCodeMelli(state.values.nationalCode)) {
    //   er.nationalCode = 'کدملی معتبر وارد نمائید.';
    // }
    const mobile = checkMobile(state.values.mobilePhone);
    if (mobile === false) {
      er.mobilePhone = 'شماره موبایل صحیح وارد نمائید.';
    } else {
      dispatch({ type: 'CHANGE_FIELD', payload: { mobilePhone: mobile } });
    }
    // if (state.values.legal) {
    //   if (!state.values.company || state.values.company.length < 3) {
    //     er.company = 'نام شرکت بایستی حداقل ۳ حرف داشته باشد.';
    //   }
    //   if (
    //     !state.values.companyNationalCode ||
    //     state.values.companyNationalCode.length !== 12
    //   ) {
    //     er.companyNationalCode = 'شناسه ملی شرکت بایستی ۱۲ رقم باشد.';
    //   }
    //   if (!state.values.phone || state.values.phone.length !== 11) {
    //     er.phone = 'شماره تلفن شرکت بایستی ۱۱ رقم باشد. مانند: ۰۲۱۲۲۳۳۴۴۵۵';
    //   }
    //   if (!state.values.zipcode || state.values.zipcode.length !== 10) {
    //     er.zipcode = 'کدپستی بایستی ۱۰ رقم باشد.';
    //   }
    //   if (!state.values.address) {
    //     er.address = 'آدرس بایستی وارد شود.';
    //   }
    // }

    // Validation patterns end here.

    if (isSingleValidation) {
      let err = {};

      for (const v in state.values) {
        if (state.values[v]) {
          if (er[v]) {
            err[v] = er[v];
          }
        }
      }
      if (Object.entries(err).length) {
        dispatch({ type: 'ERROR', payload: err });
        return false;
      }
      {
        dispatch({ type: 'ERROR', payload: {} });
        return true;
      }
    } else {
      if (Object.entries(er).length) {
        dispatch({ type: 'ERROR', payload: er });
        return false;
      }
      dispatch({ type: 'ERROR', payload: er });
      return true;
    }
  };


  const handleSubmit = async () => {
    if (validation()) {
      try {
        setLoading(true);
        if (mode === 'add') {
          const { data } = await axios.post(
            `/api/v1/admin/users/customer`,
            state.values
          );
          showMessage(data.messages);
          history.replace(`/protected/admin/users/customer/${data.values._id}`);
        } else {
          let { data } = await axios.put(
            `/api/v1/admin/users/customer/${state.values._id}`,
            state.values
          );
          showMessage(data.messages);
          data.values.city = data.values.city
            ? { label: data.values.city.title, value: data.values.city._id }
            : null;
          data.values.state = data.values.state
            ? { label: data.values.state.title, value: data.values.state._id }
            : null;
          dispatch({ type: 'LOAD', payload: data.values });
          history.replace(`/protected/admin/users/customer/${data.values._id}`);
        }
      } catch (error) {
        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.code === 11000
        ) {
          showError('کاربری دیگر با این شماره موبایل موجود می باشد.');
          return;
        }
        showError(error);
      } finally {
        setLoading(false);
      }
    } else {
      showError('خطاهای مشخص شده را بررسی کنید.');
    }
  };

  useEffect(() => {
    if (mode === 'edit') {
      values.city = values.city
        ? { label: values.city.title, value: values.city._id }
        : null;
      values.state = values.state
        ? { label: values.state.title, value: values.state._id }
        : null;
      dispatch({ type: 'LOAD', payload: values });
    }
  }, [mode]);

  return (
    <Provider value={{ state, dispatch, validation }}>
      <TwoCards
        title={mode === 'add' ? 'افزودن صاحب بار' : 'ویرایش صاحب بار'}
        category={
          mode === 'add'
            ? 'برای افزودن صاحب بار توسط مدیر سیستم'
            : 'ویرایش صاحب بار'
        }
        secondaryTitle="اطلاعات تکمیلی"
        secondaryCategory="آیا کابر VIP است و اطلاعات شرکت کاربر و ..."
        secondaryContent={<ExtendedForm />}
      >
        <Form />
        <Button
          onClick={handleSubmit}
          variant="contained"
          color="primary"
          style={{ marginTop: 15 }}
          disabled={loading}
          endIcon={loading ? <CircularProgress size={10} /> : <></>}
        >
          {mode === 'add' ? 'افزودن' : 'ویرایش'}
        </Button>
      </TwoCards>
    </Provider>
  );
};

export default React.memo(AddCustomer);
